// Copyright (c) 2021, Oracle and/or its affiliates. All rights reserved.
// Licensed under the Universal Permissive License v 1.0 as shown at http://oss.oracle.com/licenses/upl.
define('Questions.Collection.View', [
    'SCCollectionView',
    'Question.View',
    'question_collection.tpl'
    
], function (
    SCCollectionViewModule,
    QuestionView,
    template
    
) {
    'use strict';

    var SCCollectionView = SCCollectionViewModule.SCCollectionView;

    function QuestionsCollectionView (options) {
        SCCollectionView.call(this, options.collection);
        this.collection = options.collection;
        this.template = template;
        var self = this;
    }

    QuestionsCollectionView.prototype = Object.create(SCCollectionView.prototype);
    QuestionsCollectionView.prototype.constructor = QuestionsCollectionView;

    QuestionsCollectionView.prototype.getCellViewsPerRow = function () {
        return 1
    }

    QuestionsCollectionView.prototype.getCellViewInstance = function (model) {
        return new QuestionView({
            model: model
        })
    }
    
    QuestionsCollectionView.prototype.getEvents = function () {
        return {}
    }
    
    QuestionsCollectionView.prototype.getContext = function () {
        return {}
    }

    return QuestionsCollectionView
})
